import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_stock_age_analysis_summary: { message: "idle" },
};

export const retrieve_tenant_stock_age_analysis_summary_Slice = createSlice({
 name: "retrieve_tenant_stock_age_analysis_summary",
 initialState,
 reducers: {
  success_retrieve_tenant_stock_age_analysis_summary: (state, action) => {
   state.retrieve_tenant_stock_age_analysis_summary = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_stock_age_analysis_summary: (state, action) => {
   state.retrieve_tenant_stock_age_analysis_summary = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_stock_age_analysis_summary: (state) => {
   state.retrieve_tenant_stock_age_analysis_summary = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_stock_age_analysis_summary: (state) => {
   state.retrieve_tenant_stock_age_analysis_summary = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_stock_age_analysis_summary, fail_retrieve_tenant_stock_age_analysis_summary, reset_retrieve_tenant_stock_age_analysis_summary, loading_retrieve_tenant_stock_age_analysis_summary } = retrieve_tenant_stock_age_analysis_summary_Slice.actions;

export default retrieve_tenant_stock_age_analysis_summary_Slice.reducer;